module.exports = __webpack_public_path__ + "img/coinspopup-0.de1adc01.png";